import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants/enums";

export const requestGetAllCategories = async (): Promise<Category[]> => {
  return await instance.get(ApiRoutesCategories.AllCategories);
};
